const PaymentChannelViewMode = {
  BACKOFFICE: 'BackOffice',
  PAYEE: 'Payee',
};

export { PaymentChannelViewMode };
